import React from "react";

import Carousel from "react-material-ui-carousel";

import { Container } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
    bannerContainer: {
        padding: 0,
        [theme.breakpoints.down("sm")]: {
            margin: theme.spacing(0, -2),
            width: "100vw",
        },
    },
    bannerImg: {
        marginTop: theme.spacing(13),
        width: "100%",
        [theme.breakpoints.down("sm")]: {
            marginTop: theme.spacing(13),
        },
    },
}));

const Banner = () => {
    const classes = useStyles();

    const bannerInfos = [
        {
            url: "images/RSI-banner1.png",
            alt: "Repozytorium Standardów Informacyjnych jest bazą wiedzy, obejmującą metadane o systemach informacyjnych administracji publicznej.",
        },
        {
            url: "images/RSI_banner2.PNG",
            alt: "Certyfikat innowacyjnej praktyki Forum Zarządzania Publicznego",
        },
    ];

    return (
        <React.Fragment>
            <Container maxWidth={"lg"} className={classes.bannerContainer}>
                <Carousel>
                    {bannerInfos.map(({ url, alt }, i) => (
                        <img key={i} src={url} className={classes.bannerImg} alt={alt} />
                    ))}
                </Carousel>
            </Container>
        </React.Fragment>
    );
};

export default Banner;
